"use strict";
// (C) 2019-2020 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.colorPaletteToColors = exports.colorPaletteItemToRgb = exports.isRgbColor = exports.isColorFromPalette = void 0;
var tslib_1 = require("tslib");
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
//
// Type guards
//
/**
 * Type guard checking whether the provided object is a {@link IColorFromPalette}
 *
 * @public
 */
function isColorFromPalette(obj) {
    return !isEmpty_1.default(obj) && obj.type === "guid";
}
exports.isColorFromPalette = isColorFromPalette;
/**
 * Type guard checking whether the provided object is a {@link IRgbColor}
 *
 * @public
 */
function isRgbColor(obj) {
    return !isEmpty_1.default(obj) && obj.type === "rgb";
}
exports.isRgbColor = isRgbColor;
/**
 * Returns RGB code representing the color in the provided color palette items.
 *
 * @param item - color palette item
 * @returns an `rgb(red#,green#,blue#)` code
 * @public
 */
function colorPaletteItemToRgb(item) {
    var _a = item.fill, r = _a.r, g = _a.g, b = _a.b;
    return "rgb(" + r + "," + g + "," + b + ")";
}
exports.colorPaletteItemToRgb = colorPaletteItemToRgb;
/**
 * Returns a list of RGB color codes for all items in the provided color palette.
 *
 * @param palette - color palette
 * @returns list with the same cardinality as the color palette. RGB colors appear in the same order in which
 * they appear in the palette
 * @public
 */
function colorPaletteToColors(palette) {
    return palette.map(colorPaletteItemToRgb);
}
exports.colorPaletteToColors = colorPaletteToColors;
//# sourceMappingURL=index.js.map